export default "__VITE_ASSET__e92c5db9__"